export default __webpack_public_path__ + "static/media/330_business01-jp-web.7d512e2a.png";